// /join-beta: v0.1's address for the beta signup (legacy /join-beta,
// docs/parity/auth-public.md §2.7), which old emails and pages still link.
// The request form now sits in the home page's request-access band.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/join-beta')({
  beforeLoad: () => {
    throw redirect({ to: '/', hash: 'request-access', replace: true });
  },
});
